import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import Img from '~shared/FluidImage'

export default function Mariusz() {
    const data = useStaticQuery(graphql`
        {
            file(relativePath: { eq: "About/Team/Picture/Mariusz.jpg" }) {
                childImageSharp {
                    gatsbyImageData(placeholder: NONE, layout: CONSTRAINED)
                }
            }
        }
    `).file.childImageSharp.gatsbyImageData

    return <Img data={data} />
}
